<template>
    <div class=" container product-detail">
        <div class="base-info" v-if="baseInfo">
            <div class="download-pdf">
                <el-button
                    type="primary"
                    icon="el-icon-download"
                    size="small"
                    @click="getProCodeFile()"
                    >技术规格书</el-button
                >
                <!--   <img src="../assets/icon-pdf.png" alt />
                <div>技术规格说明书</div>
                <div class="link" @click="getProCodeFile()">下载</div> -->
            </div>

            <div class="info">
                <div class="info-title">
                    <div class="cname">{{ baseInfo.name }}</div>
                    <div class="ename">{{ baseInfo.thirdName }}</div>
                    <div class="brand" style="line-height:40px;height: 33px;">
                        <font style="color:#999;font-size:14px;">品牌：</font
                        ><font style="color: #3c9539;font-size:14px;">{{
                            baseInfo.brandName
                        }}</font>
                    </div>
                </div>
                <div class="table">
                    <div>
                        <div class="label">CAS号</div>
                        <div class="value">{{ baseInfo.casCode }}</div>
                    </div>
                    <div>
                        <div class="label">物化性质</div>
                        <div class="value">{{ baseInfo.physicsTerm }}</div>
                    </div>
                    <div>
                        <div class="label">分子式</div>
                        <div class="value">{{ baseInfo.molecularFormula }}</div>
                    </div>
                    <div>
                        <div class="label">储存条件</div>
                        <div class="value">{{ baseInfo.storeTerm }}</div>
                    </div>
                    <div class="border-bottom">
                        <div class="label">分子量</div>
                        <div class="value">{{ baseInfo.molecularMass }}</div>
                    </div>
                    <div class="border-bottom">
                        <div class="label">纯度</div>
                        <div class="value">{{ baseInfo.purity }}</div>
                    </div>
                </div>
            </div>

            <div class="image">
                <img :src="baseInfo.structureImage" @load="imgLoad" alt />
            </div>
        </div>

        <div style="margin-top:20px;padding:20px;background:#ffffff;">
            <table>
                <thead>
                    <tr class="th">
                        <td>货号</td>
                        <td>包装单位</td>
                        <td>库存</td>
                        <!--  <td>产品描述</td> -->
                        <td>价格（ RMB ）</td>
                        <td>购买数量</td>
                        <td>操作</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in productList" :key="index">
                        <td width="16%">{{ item.specsNo }}</td>
                        <td width="8%">{{ item.packingUnit }}</td>
                        <td width="8%">{{ item.deliver }}</td>
                        <!--   <td width="20%" v-html="item.specsDesc"></td> -->
                        <td width="14%">
                            <div v-if="userInfo">
                                <div v-if="item.discountMoney != '0.00'">
                                    <span style="color: #ff9236;">{{ item.discountMoney }}</span>
                                    <span
                                        style="color: #999; text-decoration: line-through; font-size: 12px; margin-left: 5px;"
                                        >{{ item.originalMoneyStr }}</span
                                    >
                                </div>
                                <div v-else>询价</div>
                            </div>
                            <div v-else>会员可见</div>
                        </td>
                        <td width="15%">
                            <el-input-number
                                v-model="item.shopNum"
                                size="mini"
                                :min="1"
                                label="描述文字"
                            ></el-input-number>
                        </td>
                        <td width="12%">
                            <span
                                class="add-cart"
                                v-if="item.discountMoney != '0.00'"
                                @click="addCart(item)"
                                >加入购物车</span
                            >
                            <router-link to="/promade" tag="span" class="add-cart" v-else
                                >定制
                            </router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="table-empty" v-if="productList.length === 0">
                <i class="el-icon-document-copy"></i>
                <p>暂无数据</p>
            </div>
        </div>

        <div class="product-list">
            <el-tabs type="border-card" style="width:100%">
                <el-tab-pane label="相关产品">
                    <router-link
                        class="item"
                        v-for="(item, index) in likeList"
                        :key="index"
                        :to="'/product-detail/' + item.productId"
                    >
                        <div class="img">
                            <img :src="item.structureImage" @load="imgLoad" />
                        </div>
                        <div class="info">
                            <div class="product-name">{{ item.productName }}</div>
                            <div class="product-name">{{ item.productThirdName }}</div>
                            <div class="product-extra">
                                <p>
                                    <span class="label">品牌：</span>
                                    <span class="active">{{ item.brandName }}</span>
                                </p>
                                <p>
                                    <span class="label">CAS：</span>
                                    <span>{{ item.casCode }}</span>
                                </p>
                                <p>
                                    <span class="label">分子式：</span>
                                    <span>{{ item.molecularFormula }}</span>
                                </p>
                                <p>
                                    <span class="label">分子量：</span>
                                    <span>{{ item.molecularMass }}</span>
                                </p>
                            </div>
                        </div>
                    </router-link>
                </el-tab-pane>
                <el-tab-pane label="COA查询">
                    <el-form ref="ruleForm" status-icon :model="ruleForm" label-width="100px">
                        <el-form-item
                            label="请输入批号："
                            prop="batchNo"
                            style="margin-bottom:10px"
                        >
                            <el-input
                                v-model="ruleForm.batchNo"
                                placeholder="请输入批号"
                                size="small"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="请输入货号："
                            prop="specsNo"
                            style="margin-bottom:10px"
                        >
                            <el-input
                                v-model="ruleForm.specsNo"
                                placeholder="请输入货号"
                                size="small"
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onSubmitValidate">查询</el-button>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import * as apis from '../fetch/search';
import * as apiss from '../fetch/common';
import * as orderApis from '../fetch/order';
import * as userApis from '../fetch/user';
import Hot from '../components/hot/Hot';

import { mapActions } from 'vuex';

export default {
    name: 'product-detail',
    components: {
        Hot,
    },
    computed: {
        id() {
            return this.$route.params.id;
        },
    },
    data() {
        return {
            productList: [],
            baseInfo: null,
            likeList: [],
            userInfo: null,
            ruleForm: {
                batchNo: '',
                specsNo: '',
            },
            rules: {
                batchNo: [{ required: true, message: '请输入批号', trigger: 'blur' }],
                specsNo: [{ required: true, message: '请输入货号', trigger: 'blur' }],
            },
        };
    },
    watch: {
        $route() {
            this.getHeader();
            this.getList();
            this.getLikeList();
        },
    },
    methods: {
        ...mapActions(['setreloadUserState']),
        getUserInfo() {
            userApis.getUserInfo().then(res => {
                console.log(res);
                this.userInfo = res;
            });
        },
        onSubmitValidate() {
            this.$refs['ruleForm'].validate(valid => {
                if (valid) {
                    this.onSubmit();
                } else {
                    return false;
                }
            });
        },
        onSubmit() {
            const params = { ...this.ruleForm };
            apiss.getCoa(params).then(res => {
                window.open(res);
            });
        },
        getHeader() {
            apis.getDetailHeader({ productId: this.id }).then(res => {
                this.baseInfo = res;
            });
        },
        getList(page = 1) {
            apis.getDetailList({ productId: this.id, page, pageSize: 10 }).then(res => {
                this.productList = res.map(r => ({ ...r, shopNum: 1 }));
            });
        },
        handleCurrentChange(page) {
            this.getList(page);
        },
        addCart(item) {
            orderApis.addToCart(item.id, item.shopNum).then(res => {
                this.$message({
                    message: '添加成功',
                    type: 'success',
                });
                this.setreloadUserState(true);
            });
        },
        getLikeList() {
            apis.getLikeList({ productId: this.id }).then(res => {
                this.likeList = res;
            });
        },
        getProCodeFile() {
            apis.getProCodeFile({ productId: this.id }).then(res => {
                console.log(res);
                window.open(res);
            });
        },
        imgLoad(self) {
            var _img = self.target;
            var _imgWidth = _img.naturalWidth;
            var _imgHeight = _img.naturalHeight;
            if (_imgHeight > 150 || _imgWidth > 150) {
                if (_imgHeight - _imgWidth >= 0) {
                    _img.height = 150;
                    _img.width = (150 / _imgHeight) * _imgWidth;
                    //$(obj).css("height","161");
                    //$(obj).css("width",161/_imgHeight*_imgWidth);
                } else {
                    _img.width = 150;
                    _img.height = (150 / _imgWidth) * _imgHeight;
                    //$(obj).css("width","161");
                    //$(obj).css("height",161/_imgWidth*_imgHeight);
                }
            }
            var height = _img.height / 2;
            var width = _img.width / 2;

            _img.style.marginTop = -height + 'px';
            _img.style.marginLeft = -width + 'px';
            // $(obj).css("margin-top",-height);
            //$(obj).css("margin-left",-width);
        },
    },
    mounted() {
        this.getHeader();
        this.getList();
        this.getLikeList();
        this.getUserInfo();
    },
};
</script>

<style lang="less" scoped>
.title {
    margin: 40px 0 30px;
    font-size: 16px;
    color: #282b35;
    .desc {
        font-size: 12px;
        color: #dee0e5;
        margin-top: 4px;
    }
}
.table-empty {
    margin: 0 auto;
    padding: 50px 0;
    background-color: #fff;
}
.download-pdf {
    display: flex;
    align-items: center;
    font-size: 12px;
    position: absolute;
    right: 192px;
    z-index: 9999;
    bottom: 28px;
    img {
        width: 29px;
        margin-right: 5px;
    }
    .link {
        color: #3c9539;
        margin-left: 5px;
        cursor: pointer;
    }
}

.product-list {
    background: #ffffff;
    margin-top: 20px;
    padding: 20px;
    .el-tab-pane {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .item {
        width: 210px;
        background: #ffffff;
        border-radius: 4px;
        display: block;
        color: #333;
        overflow: hidden;
        box-shadow: #e8ebed 1px 1px 2px;
        border: 1px solid #f1f1f1;
        .img {
            height: 150px;
            padding: 20px 49px;
            text-align: center;
            position: relative;
            img {
                position: absolute;
                top: 50%;
                left: 50%;
            }
        }
        .info {
            border-top: 1px dashed #eeeeee;
            padding: 12px;
            .product-name {
                font-size: 14px;
                color: #444;
                line-height: 24px;
            }
            .product-extra {
                display: flex;
                flex-wrap: wrap;
                p {
                    width: 50%;
                    margin: 0;
                    font-size: 10px;
                    line-height: 20px;
                    .label {
                        color: #999;
                    }
                    .active {
                        color: #3c9539;
                    }
                }
            }
        }
    }
}
.base-info {
    display: flex;
    align-items: center;
    padding: 20px 120px 20px 100px;
    border-bottom: 1px solid rgba(204, 204, 204, 0.5);
    position: relative;
    background: #ffffff;
    .image {
        width: 220px;
        height: 220px;
        background-color: #ffffff;
        border: solid 0px rgba(204, 204, 204, 0.5);
        margin-right: 20px;
        text-align: center;
        padding: 30px;
        position: relative;
        top: -20px;

        img {
            position: absolute;
            top: 50%;
            left: 50%;
        }
    }
    .info {
        flex: 1;
        .info-title {
            font-size: 16px;
            line-height: 28px;
            .cname {
                font-size: 18px;
                color: #3c9539;
                height: 30px;
                line-height: 30px;
            }
            .ename {
                font-size: 16px;
                color: #a6a6a6;
                height: 30px;
                line-height: 30px;
            }
        }
        .table {
            display: flex;
            flex-wrap: wrap;
            margin-top: 29px;

            & > div {
                width: 340px;
                height: 45px;
                line-height: 45px;
                display: flex;
                font-size: 12px;
                margin-right: 20px;
                border: 1px solid #e6e6e6;
                border-bottom: none;
                background-color: #fff;
                .label {
                    width: 100px;
                    padding: 0 20px;
                    border-right: 1px solid #e6e6e6;
                    background-color: #eeeeee;
                    color: #6f6969;
                }
                .value {
                    padding: 0 14px;
                    color: #6f6969;
                }
            }
            .border-bottom {
                border-bottom: 1px solid #e6e6e6;
            }
        }
    }
}

.add-cart {
    width: 88px;
    margin: 0 8px;
    line-height: 32px;
    background-color: #ff9236;
    border-radius: 20px;
    display: inline-block;
    color: #fff;
    font-size: 12px;
    cursor: pointer;
}
</style>
